import React from "react";
import LinkArticolo from "../modificaProdotti/schedaArticolo/LinkArticolo";
import { STATI, STATI_IMMAGINI } from "../backfill/statiBackfill";
import { STATO_ARTICOLI_ANAGRAFICA_IDS, STATO_ARTICOLI_COLUMN_METADATA } from "./statoArticoliColumnMetadata";
import "./statoArticoli.css";

const checkpointKeys = {
  backfillVigBot: "VIG_TO_BOT", backfillBotVig: "BOT_TO_VIG",
  backfillRecuperoBot: "BOT_RECOVERY", backfillImmaginiBot: "IMMAGINI_BOT",
};
const visibilityLabels = { both: "Catalogo e ricerca", catalog: "Solo catalogo", search: "Solo ricerca", none: "Non visibile" };
const onlinePresent = new Set(["PRESENTE", "ALLINEATO"]);
const stateTones = {
  DONE: "verde", SUCCESS: "verde", PRONTE: "verde",
  PENDING: "blu", WAITING: "blu", SCHEDULED: "blu", PARZIALI: "blu",
  REVIEW: "arancio",
  ERROR: "rosso", REJECTED: "rosso",
  NO_SOURCE: "grigio", TARGET_NOT_EMPTY: "grigio", DA_TRADURRE: "grigio",
};
const statusPill = (text, status, title) => <span
  className={`stato-articoli-pill stato-articoli-pill--${stateTones[status] ?? "grigio"}`} title={title}>
  {text}
</span>;
const missing = (title) => <span title={title}>—</span>;
const yesNo = (value, title, label = value ? "Sì" : "No") => <span
  role="img" aria-label={label} title={title} className={value ? "scrittaVerde" : "scrittaRosso"}>
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
    <path d={value ? "M5 12l4 4L19 6" : "M6 6l12 12M6 18L18 6"} />
  </svg>
</span>;
const date = (value) => {
  if (!value) return "—";
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? String(value) : parsed.toLocaleString("it-IT");
};
const languageTitle = (value, field) => value.lingueAttese.map((language) =>
  `${language}: ${value.lingue?.[language]?.[field] ?? (field === "domino" ? "MANCANTE" : "NON_VERIFICATO")}`,
).join(" · ");

export function StatoArticoliCell({ id, row }) {
  if (checkpointKeys[id]) {
    const checkpoint = row.statoBackfill?.[checkpointKeys[id]];
    if (!checkpoint) return statusPill("—", undefined, "Nessun checkpoint");
    const images = id === "backfillImmaginiBot";
    const title = [
      `Aggiornato: ${date(checkpoint.updatedAt)}`, `Prossimo controllo: ${date(checkpoint.nextCheckAt)}`,
      ...(images ? [`Immagini sorgente: ${checkpoint.sourceImageCount ?? "—"}`, `Ultimo errore: ${checkpoint.lastError ?? "—"}`] : []),
    ].join(" · ");
    return statusPill((images ? STATI_IMMAGINI : STATI)[checkpoint.status] ?? checkpoint.status, checkpoint.status, title);
  }
  const site = id.endsWith("Vig") ? "VIG" : "BOT";
  const translation = row.statoTraduzioni?.[site];
  const report = row.prestashopSites?.[site];
  if (id.startsWith("traduzioni")) {
    if (!translation || !Object.keys(translation.lingue ?? {}).length) return statusPill("—", undefined, "Nessuno stato traduzioni");
    const expected = translation.lingueAttese ?? [];
    const ready = expected.filter((language) => translation.lingue?.[language]?.domino === "PRONTO").length;
    const status = ready === 0 ? "DA_TRADURRE" : ready === expected.length ? "PRONTE" : "PARZIALI";
    return statusPill(`${ready}/${expected.length} pronte`, status,
      languageTitle({ ...translation, lingueAttese: expected }, "domino"));
  }
  if (id.startsWith("testi")) {
    if (!translation || !Object.keys(translation.lingue ?? {}).length) return missing("Nessuno stato traduzioni");
    const expected = translation.lingueAttese ?? [];
    return yesNo(expected.every((language) => onlinePresent.has(translation.lingue?.[language]?.online)),
      languageTitle({ ...translation, lingueAttese: expected }, "online"));
  }
  if (id.startsWith("pubblicato")) {
    return yesNo(report?.attivo === 1, !report ? "Non presente nel report 1000"
      : report.attivo === 1 ? "Attivo nel report 1000" : `Disattivo: ${report.deactivationReason ?? "—"}`);
  }
  if (id.startsWith("immagini")) {
    return report?.numImmagini == null ? missing() : yesNo(report.numImmagini > 0, `Immagini nel report 1000: ${report.numImmagini}`);
  }
  const visibility = report?.visibility;
  if (visibility === "both" || visibility === "none") {
    return yesNo(visibility === "both", visibilityLabels[visibility], visibilityLabels[visibility]);
  }
  return visibility ? <span title={visibility}>{visibilityLabels[visibility] ?? visibility}</span> : missing();
}

export function buildStatoArticoliColumns(baseColumns) {
  return STATO_ARTICOLI_COLUMN_METADATA.map((meta) => {
    if (STATO_ARTICOLI_ANAGRAFICA_IDS.includes(meta.id)) {
      const base = baseColumns.find(({ id }) => id === meta.id);
      if (meta.id !== "codiceVS") return base;
      return { ...base, cell: (row) => <LinkArticolo codVS={base.selector(row)}><strong>{base.selector(row)}</strong></LinkArticolo> };
    }
    return { id: meta.id, name: meta.header, sortable: false, minWidth: "150px", wrap: true,
      cell: (row) => <StatoArticoliCell id={meta.id} row={row} /> };
  });
}
